import React, { useEffect, useRef } from "react";
import cx from "classnames";

import styles from "./PageHeader.scss";

interface PageHeaderProps {
  header: string;
  children?: React.ReactNode;
  subheader?: string;
  className?: string;
  hasBottomMargin?: boolean;
  isBoldHeader?: boolean;
  isSmallSubheader?: boolean;
  isSubheaderCapped?: boolean;
  isCentered?: boolean;
  customHeaderStyles?: string;
}

const PageHeader = ({
  header,
  subheader,
  isBoldHeader = false,
  isSmallSubheader = false,
  isSubheaderCapped = false,
  isCentered = false,
  hasBottomMargin = false,
  className,
  customHeaderStyles,
  children
}: PageHeaderProps) => {
  const headerRef = useRef<HTMLHeadingElement>(null);
  const subheaderRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const setSubheaderWidth = () => {
      const subheaderElement = subheaderRef.current;

      if (isSubheaderCapped && subheaderElement && headerRef.current) {
        const headerWidth = headerRef.current.offsetWidth;

        subheaderElement.style.maxWidth = `${headerWidth}px`;
      }
    };

    setSubheaderWidth();

    window.addEventListener("resize", setSubheaderWidth);

    return () => {
      window.removeEventListener("resize", setSubheaderWidth);
    };
  }, [isSubheaderCapped]);

  return (
    <div
      className={cx(styles.wrapper, className, {
        [styles.margin]: hasBottomMargin,
        [styles.centeredWrapper]: isCentered
      })}
    >
      <div>
        <h1
          ref={headerRef}
          className={cx({ [styles.boldHeader]: isBoldHeader }, styles.header, customHeaderStyles)}
        >
          {header}
        </h1>
        {subheader && (
          <p
            ref={subheaderRef}
            className={cx({ [styles.smallSubheader]: isSmallSubheader }, styles.subHeader)}
          >
            {subheader}
          </p>
        )}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};

export default PageHeader;
